var O = Object.defineProperty;
var g = (e, n, s) => n in e ? O(e, n, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[n] = s;
var i = (e, n, s) => g(e, typeof n != "symbol" ? n + "" : n, s);
import z, { HttpStatusCode as b } from "axios";
class r extends Error {
  constructor(s, a, d, t) {
    super(s);
    i(this, "status");
    i(this, "message");
    i(this, "code");
    i(this, "data");
    Object.setPrototypeOf(this, r.prototype), this.name = this.constructor.name, this.status = a, this.message = s, this.code = d, this.data = t;
  }
}
function I(e, n) {
  const s = z.create(n);
  s.interceptors.response.use(d, a), e.addSessionListener((t) => {
    s.defaults.headers.common.Authorization = t.tokens.access ? `Bearer ${t.tokens.access}` : !1;
  });
  async function a(t) {
    var u, h, p, f, m, l, w, x, k;
    const { config: o } = t, c = ((u = t.response) == null ? void 0 : u.status) ?? 500, R = (p = (h = t == null ? void 0 : t.response) == null ? void 0 : h.data) == null ? void 0 : p.message, E = (m = (f = t == null ? void 0 : t.response) == null ? void 0 : f.data) == null ? void 0 : m.code;
    if (t.status === 400)
      throw new r(
        "Validation error",
        t.status,
        "validation-error",
        U(((w = (l = t.response) == null ? void 0 : l.data) == null ? void 0 : w.errors) ?? {})
      );
    if (o && (c === b.Unauthorized || t.code === "ERR_NETWORK")) {
      if ((x = o.headers) != null && x.Authorization && o.maxRedirects !== 42) {
        const y = o.headers.Authorization.split(" ")[1];
        if (y && T(y) && o.maxRedirects !== 42)
          return await e.refreshTokens().catch((A) => {
            throw console.error("Error refreshing tokens: ", A), e.signOut(), new r("User not authenticated.", c, "no-authentication");
          }).then(async () => (o != null && o.headers && (o.headers.Authorization = `Bearer ${e.session.tokens.access}`), await s.request({
            ...o,
            maxRedirects: 42
          })));
      }
      throw new r("User not authenticated.", c, "no-authentication");
    }
    throw new r(R, c, E, (k = t.response) == null ? void 0 : k.data);
  }
  async function d(t) {
    return t.data;
  }
  return s;
}
function T(e) {
  return Date.now() >= JSON.parse(atob(e.split(".")[1])).exp * 1e3;
}
function U(e) {
  const n = {};
  for (const s in e) {
    const a = Object.keys(e[s])[0];
    n[s] = {
      type: a,
      message: e[s][a]
    };
  }
  return n;
}
export {
  r as ApiError,
  I as createAxiosInstance,
  U as transformApiValidationErrors
};
//# sourceMappingURL=axios.js.map
